class ExtendEventHandlers extends ValidatorForm.EventHandlers {
	constructor(validator) {
		super();
		this.validator = validator
	}

	submitForm () {
		this.validator.form.querySelector('.loading').classList.remove('close');
		return true
	}

	asyncSuccess (url, response) {
		if (url) window.location.href = url
		else window.location.reload()
	}
	asyncFailed (url, response) {
		if (url) window.location.href = url
		else window.location.reload()
	}

}
window.ExtendEventHandlers = ExtendEventHandlers



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_customform/script.js